import React from "react";

import classNames from "classnames";
import { Button, Col, Row } from "react-bootstrap";

import AdjustGameLengths from "./AdjustGameLengths";
import AdjustStartTimes from "./AdjustStartTimes";
import MoveGames from "./MoveGames";

import { useScheduleActionsContext } from "../contexts/ScheduleActions";
import { useFormHandlers } from "../hooks/useFormHandlers";

const PageContent = (): React.JSX.Element => {
    const { showComponent } = useScheduleActionsContext();
    const { onSubmit } = useFormHandlers();

    return (
        <React.Fragment>
            {showComponent["moveGames"] && (
                <Row className={classNames("mt-3")}>
                    <Col>
                        <MoveGames />
                    </Col>
                </Row>
            )}
            {showComponent["adjustStarts"] && (
                <Row className={classNames("mt-3")}>
                    <Col>
                        <AdjustStartTimes />
                    </Col>
                </Row>
            )}
            {showComponent["adjustLengths"] && (
                <Row className={classNames("mt-3")}>
                    <Col>
                        <AdjustGameLengths />
                    </Col>
                </Row>
            )}
            <Row className={classNames("mt-3")}>
                <Col>
                    <Button onClick={onSubmit}>Save</Button>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default PageContent;
